import { ArrowDownWideNarrow, ArrowUpDown, ArrowUpNarrowWide } from 'lucide-react';
import type { SorterProps } from './types';
import { SortingOrder } from './types';

const Sorter = ({ column, onSortOrderChange }: SorterProps) => (
    <button
        className="group inline-flex w-full items-center justify-between"
        data-cy="tableSort"
        onClick={() => onSortOrderChange(column.key, column.sortOrder)}
        type="button"
    >
        <span className="w-full text-left">{column.title}</span>
        <span className="ml-3 flex-none rounded text-gray-500 group-hover:visible group-focus:visible">
            {column.sortOrder === SortingOrder.Asc && <ArrowUpNarrowWide aria-hidden="true" className="h-5 w-5" />}
            {column.sortOrder === SortingOrder.Desc && <ArrowDownWideNarrow aria-hidden="true" className="h-5 w-5" />}
            {!column.sortOrder && <ArrowUpDown aria-hidden="true" className="h-5 w-5" />}
        </span>
    </button>
);

export default Sorter;
